export default class Overlay {
  constructor(overlayId = 'overlayElement') {
    this.overlayId = overlayId;
    this.overlayClass = `nhs-c-overlay--fullsize nhs-u-background-color--black-1000-opacity-60 nhs-u-fixed nhs-u-z-index--modal`;
    this.overlayDataAttr = 'data-overlay-element';
    this.isMacOS = navigator.userAgent.indexOf('Mac') > -1;
  }

  getOverlay() {
    return document.getElementById(this.overlayId);
  }

  create() {
    requestAnimationFrame(() => {
      if (this.getOverlay()) {
        return;
      }

      if (this.isMacOS) {
        // Adding sticky to prevent white space below the modal on macOS.
        document.body.classList.add('nhs-u-sticky');
      }
      
      document.body.classList.add('nhs-u-overflow--hidden');
      document.body.insertAdjacentHTML('beforeend', this.getHtml());
    });
  }

  remove() {
    requestAnimationFrame(() => {
      const overlay = this.getOverlay();
      if (!overlay) {
        return;
      }

      overlay.remove();

      // Another modal's overlay may still be open underneath (stacked modals) — only release the
      // shared body scroll-lock once no overlay element remains.
      if (document.querySelector(`[${this.overlayDataAttr}]`)) {
        return;
      }

      if (this.isMacOS) {
        document.body.classList.remove('nhs-u-sticky');
      }

      document.body.classList.remove('nhs-u-overflow--hidden');
    });
  }

  getHtml() {
      return `<div id="${this.overlayId}" class="${this.overlayClass}" ${this.overlayDataAttr}></div>`;
  }
}
